export default "__VITE_ASSET__BLpgOKt___"